import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { AssetInsight, SceneInsight } from "./types/insight.type";

export interface GetAllInsightsReq {
  projectId: string;
  studyId: string;
  sortBy?: "asc" | "desc";
}
export interface GetAllAssetInsightsReq extends GetAllInsightsReq {
  orderBy?: "attention" | "clarity" | "digestibility" | "visibility" | "memory" | "emotion" | "creative" | "name";
}

export interface GetAllSceneInsightsReq extends GetAllInsightsReq {
  orderBy?: "vis" | "pop" | "soa" | "pow";
}

/*
 * getAllAssetInsights endpoint
 *
 * This endpoint is used to get all insights for every asset in a study.
 * It will only have insights data if it has been processed in the pipeline.
 */
export const getAllAssetInsights = async ({ projectId, studyId, sortBy, orderBy }: GetAllAssetInsightsReq) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/assets/insights`, {
    params: {
      sortBy,
      orderBy,
    },
  });
  return resp.data as AssetInsight[];
};

/*
 * getAllSceneInsights endpoint
 *
 * This endpoint is used to get all insights for every scene in a study.
 * It will only have insights data if it has been processed in the pipeline.
 */
export const getAllSceneInsights = async ({ projectId, studyId, sortBy, orderBy }: GetAllSceneInsightsReq) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/v3/studio/projects/${projectId}/studies/${studyId}/scenes/insights`, {
    params: {
      sortBy,
      orderBy,
    },
  });
  return resp.data as SceneInsight[];
};
